import Long from 'long';

import { concat, filter, orderBy } from 'es-toolkit/compat';
import { dashboard } from 'types';
import { safeToNumber } from '@tock/coretypes';
import AppConstants from 'constants/AppConstants';

export type Table = Overwrite<
  dashboard.Table,
  {
    id: Long;
    location: dashboard.TableLocation;
  }
>;

export interface State {
  archivedTables: Table[];
  data?: Table[];
  isInitialized: boolean;
  isRequesting: boolean;
  selectedRoomId: string | null;
}

const initialState: State = {
  archivedTables: [],
  data: undefined,
  isInitialized: false,
  isRequesting: false,
  selectedRoomId: null,
};

export default function reducer(state = initialState, action: BaseTockAction): State {
  const { type, payload, context } = action;
  switch (type) {
    case AppConstants.TABLES_FETCH_ALL_STARTING: {
      return {
        ...state,
        isInitialized: false,
        isRequesting: true,
      };
    }

    case AppConstants.TABLES_FETCH_ALL_DONE: {
      return {
        ...state,
        data: orderBy(payload, 'name'),
        isInitialized: true,
        isRequesting: false,
      };
    }

    case AppConstants.TABLES_FETCH_ALL_FAILED: {
      return {
        ...state,
        isInitialized: true,
        isRequesting: false,
      };
    }

    case AppConstants.TABLES_FETCH_ARCHIVED_STARTING:
    case AppConstants.TABLES_FETCH_ARCHIVED_FAILED: {
      return state;
    }

    case AppConstants.TABLES_FETCH_ARCHIVED_DONE: {
      return {
        ...state,
        archivedTables: payload,
      };
    }

    case AppConstants.TABLES_ADD_DONE: {
      const newData = concat(state.data, [payload]);
      return {
        ...state,
        data: newData,
      };
    }

    case AppConstants.TABLES_UPDATE_DONE: {
      const newData = concat(
        filter(state.data, (table) => {
          return safeToNumber(table.id) !== safeToNumber(payload.id);
        }),
        payload
      );

      return {
        ...state,
        data: newData,
      };
    }

    case AppConstants.TABLES_DELETE_DONE: {
      const newData = filter(state.data, (table) => {
        return safeToNumber(table.id) !== safeToNumber(context.deletedTable.id);
      });

      return {
        ...state,
        data: newData,
      };
    }

    case AppConstants.TABLES_SELECT_ROOM: {
      return {
        ...state,
        selectedRoomId: payload,
      };
    }

    default:
      return state;
  }
}
